import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { translate } from "../../i18n/customI18nProvider";

export default function PaymentSuccess({onClose}) {

    useEffect(() => {
        const timer = setTimeout(() => {
            if(onClose) {
                onClose();
            }
        }, 3000);

        return () => clearTimeout(timer);
    }, [onClose]);

  return (
    <div style={container}>
      <style>{animations}</style>

      <svg className="success-svg" viewBox="0 0 54 54">
        <circle className="circle" cx="27" cy="27" r="25" fill="none" />
        <path className="check" fill="none" d="M16 27l7 7 16-16" />
      </svg>

      <p className="success-text">{translate("custom.payment_success")}</p>
    </div>
  );
}

const container = {
    height: "calc(100vh - 164px)",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    fontFamily: "system-ui, sans-serif",
};

const animations = `
.success-svg {
  width: 120px;
  height: 120px;
}

.circle {
  stroke: #4caf50;
  stroke-width: 4;
  stroke-dasharray: 157;
  stroke-dashoffset: 157;
  animation: stroke 0.6s ease-out forwards;
}

.check {
  stroke: #4caf50;
  stroke-width: 4;
  stroke-dasharray: 48;
  stroke-dashoffset: 48;
  animation: stroke 0.4s 0.6s ease-out forwards;
}

.success-text {
  margin-top: 24px;
  font-size: 22px;
  color: #1f2937;
  opacity: 0;
  animation: fadeIn 0.5s 0.9s forwards;
}

@keyframes stroke {
  to {
    stroke-dashoffset: 0;
  }
}

@keyframes fadeIn {
  to {
    opacity: 1;
  }
}
`;